import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql, navigate } from 'gatsby';
import { localizedPath } from 'gatsby-theme-i18n/src/helpers';
import { LocalizedLink as Link } from 'gatsby-theme-i18n';
import styled from 'styled-components';
import { MDXRenderer } from 'gatsby-plugin-mdx';

import { withLocale, filterEdgesByLocale } from '../helpers';
import Submenu from './Submenu';
import SubmenuMobile from './SubmenuMobile';
// import { Helmet } from 'react-helmet';

const NavbarSection = styled.section`
  background-color: ${(props) => props.bgColor};
`;

const NavbarContainer = styled.nav`
  max-width: 1920px;
  display: flex;
  flex-shrink: 0;
  flex-grow: 0;
  width: 100%;
  height: 100px;
  z-index: 1;
  align-items: center;
  justify-content: space-between;
  padding-top: 15px;
  padding-bottom: 15px;
  margin: auto;

  & a {
    text-decoration: none;
    font-size: 18px;
    font-weight: 700;
    color: var(--color-white);
  }

  & a:hover {
    color: ${(props) => props.colorLinkHover};
    cursor: pointer;
  }

  & div {
    font-size: 18px;
    font-weight: 700;
    color: var(--color-white);

    &:hover {
      color: ${(props) => props.colorLinkHover};
      cursor: pointer;
    }
  }
`;

const LogoNavbar = styled.img`
  width: 10%;
  cursor: pointer;
  padding-right: 1.5%;

  @media (max-width: 2120px) {
    padding-left: 100px;
  }

  @media (max-width: 1370px) {
    padding-left: 50px;
  }
`;

const LeftSectionNavbar = styled.div`
  display: flex;
  width: 60%;

  & >div {
    margin-right: 4%;
  }
`;

const RightSectionNavbar = styled.div`
  display: flex;
  width: 20%;
  justify-content: right;

  & >div, >a {
    margin-left: 12%;
  }


`;

const LanguageSwitch = styled.div`
  display: flex;
  gap: 8px;

  & a {
    position: relative;
  }

  & a.active::after {
    content: '';
    position: absolute;
    height: 4px;
    border-radius: 2px;
    bottom: -7.5px;
    background-color: rgba(255, 255, 255, 0.6);
    right: 0;
    left: 0;
  }
`;

const ContactButton = styled.button`
  width: 240px;
  color: var(--color-white);
  background-color: var(--color-magenta);
  font-size: 18px;
  font-weight: 700;
  padding: 5px 10px;
  transition: none;
  margin-left: 2%;

  &:before {
    display: none;
  }

  &:after {
    display: none;
  }

  &:hover {
    background-size: 0;
  }

  @media (max-width: 2120px) {
    margin-right: 100px;
  }

  @media (max-width: 1370px) {
    margin-right: 50px;
  }

`;

const NavbarContainerMobile = styled.div`
  display: flex;
  flex-direction: column;
`;

const NavbarMobile = styled.div`
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LogoNavbarMobile = styled.img`
  height: 28px;
  margin-left: 50px;

  &:hover {
    cursor: pointer;
  }

  @media (max-width: 1023px) {
    margin-left: 25px;
  }

  @media (max-width: 550px) {
    height: 25px;
  }
`;

const BurgerMenu = styled.input`
  color: white;
  width: 48px;
  height: 48px;
  background: linear-gradient(0, currentColor, currentColor);
  background-size: 40px 3px;
  background-position: 3px 22px;
  background-repeat: no-repeat;
  border: 0 none;
  padding: 0;
  margin-right: 45px;
  position: relative;
  appearance: none;
  transition: background-size 1ms ease, background-position 1ms ease;
  transition-delay: 300ms;

  &:before, &:after {
    content: ' ';
    display: block;
    position: absolute;
    width: 40px;
    height: 3px;
    background-color: currentColor;
    left: 3px;
    transform: rotate(0deg);
    transition: top 300ms ease, transform 300ms ease;
    transition-delay: 300ms, 0ms;
  }

  &:before {
    top: 10px;
  }

  &:after {
    top: 34px;
  }

  &:checked {
    background-size: 3px 3px;
    background-position: 22px 22px;
  }

  &:checked:before {
    top: 22px;
    transform: rotate(45deg);
    transition-delay: 0ms, 300ms;
  }

  &:checked:after {
    top: 22px;
    transform: rotate(-45deg);
    transition-delay: 0ms, 300ms;
  }

  &:hover {
    cursor: pointer;
  }

  @media (max-width: 1023px) {
    margin-right: 20px;
  }`;

const MenuItemNavbarMobile = styled.div`
  cursor: pointer;
  font-weight: 700;

  &:hover {
    color: var(--color-magenta);
  }
`;

const MenuMobile = styled.div`
  max-height: ${(props) => (props.visible ? 'calc(100vh - 60px)' : '0')};
  pointer-events: ${(props) => (props.visible ? 'all' : 'none')};
  padding: ${(props) => (props.visible ? '50px 0' : '0px 0')};
  transition: max-height 500ms ease, padding 500ms ease;
  box-sizing: border-box;
  overflow-y: auto;
  background-color: var(--color-white);
  display: flex;
  flex-direction: column;
  gap: 25px;
  z-index: 1000;
  width: 100%;
  font-size: 20px;
  font-weight: 700;
  color: var(--color-teal);
  align-items: center;
  text-align: center;

  & a {
    color: var(--color-teal);
    text-decoration: none;

    &:hover {
      color: var(--color-magenta);
    }
  }

  @media (max-width: 550px) {
   padding-bottom: ${(props) => (props.visible ? '90px' : '0px')};
  }
`;

const LanguageSwitchMobile = styled.div`
  display: flex;
  gap: 8px;
  font-weight: 500;

  & a.active {
    font-weight: 700;
  }
`;

const ContactButtonMobile = styled(ContactButton)`
  margin: 0;
  font-size: 20px;
  font-weight: 700;

  &:hover {
    color: var(--color-white);
  }
`;

const NavbarHighlight = styled.div`
  transition: width 300ms ease, left 300ms ease, opacity 300ms ease;
  width: ${(props) => props.width || 4}px;
  height: 4px;
  border-radius: 2px;
  background-color: rgba(255, 255, 255, 0.6);
  position: absolute;
  top: 80px;
  left: ${(props) => props.left || 200}px;
  opacity: ${(props) => (props.left ? 1 : 0)}
`;

const NavbarContainerForGoogleCrawler = styled.div`
  display: none;
`;

class Navbar extends Component {
  static propTypes = {
    locale: PropTypes.string,
    i18nConfig: PropTypes.array,
    currentPath: PropTypes.string,
    backgroundColor: PropTypes.string,
    linkColorHover: PropTypes.string,
    submenuId: PropTypes.number,
  };

  static defaultProps = {
    currentPath: '',
  };

  constructor(...params) {
    super(...params);
    this.state = {
      hoverEl: null,
      selectedEl: null,
      selectedElLink: null,
      openedMenu: null,
      openedMenuEl: null,
      openMobileMenu: null,
      openedMenuMobile: null,
    };

    this.resizeTimeout = null;
    this.highlightEl = null;

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.onResize);
      document.addEventListener('click', this.onClick);

      window.setTimeout(this.onResize, 100);
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('click', this.onClick);
      if (this.resizeTimeout) {
        window.clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
    }
  }

  onResize = () => {
    if (typeof window !== 'undefined') {
      if (this.highlightEl) {
        this.highlightEl.style.opacity = 0;
      }
      if (this.resizeTimeout) {
        window.clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
      this.resizeTimeout = window.setTimeout(() => {
        if (this.highlightEl) {
          this.highlightEl.style.opacity = null;
        }
        this.forceUpdate();
      }, 500);
    }
  };

  isSubmenuElement = (el) => {
    if (!el) return false;
    if (el.classList.contains('submenu') || el.classList.contains('submenu-opener')) {
      return true;
    }
    return this.isSubmenuElement(el.parentElement);
  };

  onClick = (e) => {
    const { openedMenu } = this.state;
    if (openedMenu !== null && !this.isSubmenuElement(e.target)) {
      this.setState({ openedMenu: null, openedMenuEl: null });
    }
  };

  renderMenuItem = (link, title) => {
    const { currentPath } = this.props;
    const { selectedElLink, openedMenu } = this.state;

    return (
      <div
        ref={(el) => {
          if (el) {
            let isActive = false;
            if (link === '/') {
              isActive = link === currentPath;
            } else {
              isActive = currentPath.startsWith(link);
            }
            if (isActive && selectedElLink !== link) {
              this.setState({
                selectedEl: el,
                selectedElLink: link,
              });
            }
          }
        }}
        onFocus={(event) => {
          this.setState({ hoverEl: event.target });
        }}
        onMouseOver={(event) => {
          this.setState({ hoverEl: event.target });
        }}
        onBlur={() => {
          this.setState({ hoverEl: null });
        }}
        onMouseOut={() => {
          this.setState({ hoverEl: null });
        }}
      >
        <Link to={link} tabIndex={openedMenu !== null ? 3 : 0}>{title}</Link>
      </div>
    );
  };

  renderContent = (data) => {
    const {
      locale, i18nConfig, currentPath, backgroundColor, linkColorHover, submenuId,
    } = this.props;
    const {
      hoverEl, selectedEl, openedMenu, openedMenuEl, openMobileMenu, openedMenuMobile,
    } = this.state;
    const [contentNavigation] = filterEdgesByLocale(data?.navigation?.edges, locale);
    const contentSubmenu = filterEdgesByLocale(data?.submenus?.edges, locale);
    const contentPurposeSubpage = filterEdgesByLocale(data?.purposeSubpages?.edges, locale);
    const contentProductSubpage = filterEdgesByLocale(data?.productSubpages?.edges, locale);
    const contentReferencesSubpage = filterEdgesByLocale(data?.referencesSubpages?.edges, locale);
    const contentAllSubpages = [...contentPurposeSubpage, ...contentProductSubpage, ...contentReferencesSubpage];
    contentAllSubpages.sort((a, b) => {
      let sort = a.node.frontmatter.submenuId - b.node.frontmatter.submenuId;
      if (sort === 0) sort = a.node.frontmatter.subpageId - b.node.frontmatter.subpageId;
      return sort;
    });

    let filteredPages = [];
    if (openedMenu !== null) {
      filteredPages = contentAllSubpages.filter((n) => n?.node?.frontmatter?.submenuId === contentSubmenu?.[openedMenu].node.frontmatter.submenuId);
    }

    let filteredPagesMobile = [];
    if (openedMenuMobile !== null) {
      // eslint-disable-next-line max-len
      filteredPagesMobile = contentAllSubpages.filter((n) => n?.node?.frontmatter?.submenuId === contentSubmenu?.[openedMenuMobile].node.frontmatter.submenuId);
    }

    const hoverElRect = hoverEl?.getBoundingClientRect();
    const selectedElRect = selectedEl?.getBoundingClientRect();
    const openedMenuElRect = openedMenuEl?.getBoundingClientRect();

    return (
      <NavbarSection
        bgColor={backgroundColor}
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            this.setState({ openedMenu: null, openedMenuEl: null });
            this.setState({ openedMenuMobile: null });
          }
        }}
      >
        { typeof window !== 'undefined' && window.innerWidth > 1279 && (
          <NavbarContainer colorLinkHover={linkColorHover}>
            <LogoNavbar
              src="/img/Logo_white.png"
              alt="Presono Logo"
              onClick={() => {
                navigate(localizedPath({
                  locale,
                  path: '/',
                  defaultLang: 'de',
                  prefixDefault: false,
                }));
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  navigate(localizedPath({
                    locale,
                    path: '/',
                    defaultLang: 'de',
                    prefixDefault: false,
                  }));
                }
              }}
              tabIndex={openedMenu !== null ? 3 : 0}
            />
            <LeftSectionNavbar>
              { contentSubmenu.map((item, index) => {
                let tabIndex = 0;
                if (openedMenu !== null) {
                  tabIndex = (openedMenu >= index) ? 1 : 3;
                }
                if (item?.node?.frontmatter?.submenuId < 0) return undefined;
                return (
                  <div
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                    onFocus={(event) => {
                      this.setState({ hoverEl: event.target });
                    }}
                    onMouseOver={(event) => {
                      this.setState({ hoverEl: event.target });
                    }}
                    onBlur={() => {
                      this.setState({ hoverEl: null });
                    }}
                    onMouseOut={() => {
                      this.setState({ hoverEl: null });
                    }}
                    onClick={() => {
                      if (openedMenu === index) {
                        this.setState({ openedMenu: null, openedMenuEl: null });
                      } else {
                        this.setState({ openedMenu: index });
                      }
                    }}
                    onKeyDown={(event) => {
                      if (event.key === 'Enter') {
                        if (openedMenu === index) {
                          this.setState({ openedMenu: null, openedMenuEl: null });
                        } else {
                          this.setState({ openedMenu: index });
                        }
                      }
                    }}
                    tabIndex={tabIndex}
                    className="submenu-opener"
                    ref={(el) => {
                      if (el) {
                        if (openedMenu === index && openedMenuEl !== el) {
                          this.setState({
                            openedMenuEl: el,
                          });
                        }
                        if (submenuId === item?.node?.frontmatter?.submenuId && selectedEl !== el) {
                          this.setState({
                            selectedEl: el,
                          });
                        }
                      }
                    }}
                  >
                    {item?.node?.frontmatter?.title}
                  </div>
                );
              })}
              { this.renderMenuItem('/onboarding', contentNavigation?.node?.frontmatter?.onboardingTitleNavbar) }
              { this.renderMenuItem('/apps', contentNavigation?.node?.frontmatter?.appsTitleNavbar) }
              { this.renderMenuItem('/blog', contentNavigation?.node?.frontmatter?.blogTitleNavbar) }
            </LeftSectionNavbar>
            <RightSectionNavbar>
              <LanguageSwitch>
                {
                  i18nConfig.map((config) => {
                    return (
                      <div key={config.code}>
                        <Link
                          to={currentPath}
                          language={config.code}
                          className={locale === config.code ? 'active' : ''}
                          tabIndex={openedMenu !== null ? 3 : 0}
                        >
                          {config.code.toUpperCase()}
                        </Link>
                      </div>
                    );
                  })
                }
              </LanguageSwitch>
              <a rel="noreferrer" target="_blank" href="https://my.presono.com/login" tabIndex={openedMenu !== null ? 3 : 0}>
                {contentNavigation?.node?.frontmatter?.loginTitleNavbar}
              </a>
            </RightSectionNavbar>
            <ContactButton
              type="button"
              onClick={() => {
                navigate(localizedPath({
                  locale,
                  path: '/contact',
                  defaultLang: 'de',
                  prefixDefault: false,
                }));
              }}
            >
              {contentNavigation?.node?.frontmatter?.requestDemoTitleNavbar}
            </ContactButton>
            <NavbarHighlight
              ref={(el) => {
                this.highlightEl = el;
              }}
              left={hoverElRect?.left || openedMenuElRect?.left || selectedElRect?.left}
              width={hoverElRect?.width || openedMenuElRect?.width || selectedElRect?.width}
            />
          </NavbarContainer>
        )}
        { openedMenu !== null && typeof window !== 'undefined' && window.innerWidth > 1279 && (
          <Submenu
            subpages={filteredPages}
            menuPosition={openedMenuElRect?.left || 0}
            arrowPosition={(openedMenuElRect?.width || 0) / 2}
            locale={locale}
            data={contentSubmenu?.[openedMenu]}
          />
        )}
        <NavbarContainerMobile>
          { typeof window !== 'undefined' && window.innerWidth <= 1279 && (
            <>
              <NavbarMobile>
                <LogoNavbarMobile
                  src="/img/new_presono_logo_white_next.svg"
                  alt="Presono Logo"
                  onClick={() => {
                    navigate(localizedPath({
                      locale,
                      path: '/',
                      defaultLang: 'de',
                      prefixDefault: false,
                    }));
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      navigate(localizedPath({
                        locale,
                        path: '/',
                        defaultLang: 'de',
                        prefixDefault: false,
                      }));
                    }
                  }}
                  tabIndex={openedMenu !== null ? 3 : 0}
                />
                <BurgerMenu
                  type="checkbox"
                  onClick={() => {
                    if (openMobileMenu === null) {
                      this.setState({ openMobileMenu: true });
                    } else {
                      this.setState({ openMobileMenu: null });
                      this.setState({ openedMenuMobile: null });
                    }
                  }}
                />
              </NavbarMobile>
              <MenuMobile
                visible={openMobileMenu}
              >
                { contentSubmenu.map((item, index) => {
                  let tabIndex = 0;
                  if (openedMenuMobile !== null) {
                    tabIndex = (openedMenuMobile >= index) ? 1 : 3;
                  }
                  if (item?.node?.frontmatter?.submenuId < 0) return undefined;
                  return (
                    <div
                      // eslint-disable-next-line react/no-array-index-key
                      key={index}
                      tabIndex={tabIndex}
                      ref={(el) => {
                        if (el) {
                          if (openedMenuMobile === index && openedMenuEl !== el) {
                            this.setState({
                              openedMenuEl: el,
                            });
                          }
                        }
                      }}
                      className="submenu-opener"
                    >
                      <MenuItemNavbarMobile
                        onClick={() => {
                          if (openedMenuMobile === index) {
                            this.setState({ openedMenuMobile: null });
                          } else {
                            this.setState({ openedMenuMobile: index });
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            if (openedMenuMobile === index) {
                              this.setState({ openedMenuMobile: null });
                            } else {
                              this.setState({ openedMenuMobile: index });
                            }
                          }
                        }}
                      >
                        {item?.node?.frontmatter?.title}
                      </MenuItemNavbarMobile>
                      { openedMenuMobile === index && (
                        <SubmenuMobile
                          data={contentSubmenu?.[openedMenuMobile]}
                          subpages={filteredPagesMobile}
                          locale={locale}
                        />
                      )}
                    </div>
                  );
                })}
                { this.renderMenuItem('/onboarding', contentNavigation?.node?.frontmatter?.onboardingTitleNavbar) }
                { this.renderMenuItem('/apps', contentNavigation?.node?.frontmatter?.appsTitleNavbar) }
                { this.renderMenuItem('/blog', contentNavigation?.node?.frontmatter?.blogTitleNavbar) }
                <LanguageSwitchMobile>
                  {
                    i18nConfig.map((config) => {
                      return (
                        <div key={config.code}>
                          <Link
                            to={currentPath}
                            language={config.code}
                            className={locale === config.code ? 'active' : ''}
                            tabIndex={openedMenu !== null ? 3 : 0}
                          >
                            {config.code.toUpperCase()}
                          </Link>
                        </div>
                      );
                    })
                  }
                </LanguageSwitchMobile>
                <a rel="noreferrer" target="_blank" href="https://my.presono.com/login" tabIndex={openedMenu !== null ? 3 : 0}>
                  {contentNavigation?.node?.frontmatter?.loginTitleNavbar}
                </a>
                <ContactButtonMobile
                  type="button"
                  onClick={() => {
                    navigate(localizedPath({
                      locale,
                      path: '/contact',
                      defaultLang: 'de',
                      prefixDefault: false,
                    }));
                  }}
                >
                  {contentNavigation?.node?.frontmatter?.requestDemoTitleNavbar}
                </ContactButtonMobile>
              </MenuMobile>
            </>
          )}
        </NavbarContainerMobile>
        <NavbarContainerForGoogleCrawler>
          { contentAllSubpages.map((item, index) => {
            const urlPrefix = data?.submenus?.edges?.filter((submenu) => (submenu?.node?.frontmatter?.submenuId === item?.node?.frontmatter?.submenuId));
            const urlPrefixForGoogleCrawler = urlPrefix[0].node?.frontmatter?.urlPath;

            if (item?.node?.frontmatter?.submenuId < 0) return undefined;
            return (
              <a
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                href={localizedPath({
                  locale,
                  path: `/${urlPrefixForGoogleCrawler}/${item?.node?.frontmatter?.title}/`,
                  defaultLang: 'de',
                  prefixDefault: false,
                })}
              >
                <MDXRenderer>{item?.node?.frontmatter?.submenuSubheadline}</MDXRenderer>
              </a>
            );
          })}
          <a href={
            localizedPath({
              locale,
              path: '/blog/',
              defaultLang: 'de',
              prefixDefault: false,
            })
          }
          >
            {contentNavigation?.node?.frontmatter?.blogTitleNavbar}
          </a>
          <a href={
            localizedPath({
              locale,
              path: '/apps/',
              defaultLang: 'de',
              prefixDefault: false,
            })
          }
          >
            {contentNavigation?.node?.frontmatter?.appsTitleNavbar}
          </a>
          <a href={
            localizedPath({
              locale,
              path: '/onboarding/',
              defaultLang: 'de',
              prefixDefault: false,
            })
          }
          >
            {contentNavigation?.node?.frontmatter?.onboardingTitleNavbar}
          </a>
          <a href={
            localizedPath({
              locale,
              path: '/contact/',
              defaultLang: 'de',
              prefixDefault: false,
            })
          }
          >
            {contentNavigation?.node?.frontmatter?.requestDemoTitleNavbar}
          </a>
          <a rel="noreferrer" target="_blank" href="https://my.presono.com/login">
            {contentNavigation?.node?.frontmatter?.loginTitleNavbar}
          </a>
          {
            i18nConfig.map((config) => {
              return (
                <div key={config.code}>
                  <Link
                    to={currentPath}
                    language={config.code}
                  >
                    {config.code.toUpperCase()}
                  </Link>
                </div>
              );
            })
          }
        </NavbarContainerForGoogleCrawler>
      </NavbarSection>
    );
  };

  render() {
    return (
      <StaticQuery
        query={graphql`
          query NaviagtionQuery {
            navigation: allMdx(
              filter: {
                frontmatter: { layout: { eq: "navigation" } }
              }
            ) {
              edges {
                node {
                  frontmatter {
                    onboardingTitleNavbar
                    blogTitleNavbar
                    appsTitleNavbar
                    requestDemoTitleNavbar
                    loginTitleNavbar
                  }
                  fields {
                    locale
                  }
                }
              }
            }
            submenus: allMdx(
              sort: { order: ASC, fields: [frontmatter___submenuId] }
              filter: {
                frontmatter: { layout: {eq: "submenu"} }
              }
            ) {
              edges {
                node {
                  frontmatter {
                    submenuId
                    urlPath
                    title
                  }
                  fields {
                    locale
                  }
                }
              }
            }
            purposeSubpages: allMdx(
              filter: {
                frontmatter: { layout: {eq: "purposeSubpage"} }
              }
            ) {
              edges {
                node {
                  frontmatter {
                    title
                    submenuId
                    subpageId
                    submenuSubheadline
                    purposeSubpageSubtext
                  }
                  slug
                  id
                  fields {
                    locale
                  }
                }
              }
            }
            productSubpages: allMdx(
              filter: {
                frontmatter: { layout: {eq: "productSubpage"} }
              }
            ) {
              edges {
                node {
                  frontmatter {
                    title
                    submenuId
                    subpageId
                    submenuSubheadline
                    productSubpageSubtext
                  }
                  slug
                  id
                  fields {
                    locale
                  }
                }
              }
            }
            referencesSubpages: allMdx(
              filter: {
                frontmatter: { layout: {eq: "referencesSubpage"} }
              }
            ) {
              edges {
                node {
                  frontmatter {
                    title
                    submenuId
                    subpageId
                    submenuSubheadline
                    referencesSubpageSubtext
                  }
                  slug
                  id
                  fields {
                    locale
                  }
                }
              }
            }          }        
        `}
        render={this.renderContent}
      />
    );
  }
}

const LocalizedNavbar = withLocale(Navbar);

export default LocalizedNavbar;
